import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Zoom from 'react-medium-image-zoom';

import createAConnectionWithAwsS3_1 from '../../../../..//libraries/Images/createAConnectionWithAwsS3_1.png';
import createAConnectionWithAwsS3_2 from '../../../../..//libraries/Images/createAConnectionWithAwsS3_2.png';
import createAConnectionWithAwsS3_3 from '../../../../..//libraries/Images/createAConnectionWithAwsS3_3.png';
import createAConnectionWithAwsS3_4 from '../../../../..//libraries/Images/createAConnectionWithAwsS3_4.png';

function Vi(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createaconnectionwithawss3">
                1.&nbsp;{translate('createaconnectionwithawss3')}
            </Typography>
            <p>Nhấp vào "Thêm mới" để tạo kết nối.</p>
            <Zoom>
                <img src={createAConnectionWithAwsS3_1} width="75%" />
            </Zoom>
            <p>Một danh sách các ứng dụng có thể được liên kết sẽ hiển thị, hãy chọn "Aws S3" trong số đó.</p>
            <Zoom>
                <img src={createAConnectionWithAwsS3_2} width="75%" />
            </Zoom>
            <p>Sau khi bạn nhấp vào "Aws S3", vui lòng nhập các giá trị cần thiết rồi nhấp nút OK để hoàn tất.</p>
            <Zoom>
                <img src={createAConnectionWithAwsS3_3} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>Bạn sẽ thấy 1 thẻ Aws S3 sau khi kết nối được tạo thành công.</p>
            <Zoom>
                <img src={createAConnectionWithAwsS3_4} width="50%" />
            </Zoom>
            <p>Sử dụng <strong>Provider ID</strong> có trong thẻ này để thực hiện các bước trong Aws S3.</p>
            <br/>
        </Box>
    );
}
export default withTranslate(Vi);